import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CTAButtonProps = {
  children: React.ReactNode;
  id?: string;
  className?: string;
};
export function CTAButton({
  children,
  id,
  className = ''
}: CTAButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`group inline-flex w-full max-w-md items-center justify-center gap-2 rounded-2xl bg-gold-400 px-5 py-4 text-center font-display text-[15px] font-extrabold uppercase leading-tight tracking-tight text-navy-950 shadow-[0_6px_0_0_#B9832A,0_14px_30px_-8px_rgba(239,194,90,0.55)] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-gold-300 active:translate-y-[4px] active:shadow-[0_2px_0_0_#B9832A] focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-2 focus-visible:outline-accent-400 sm:py-5 sm:text-lg ${className}`} data-id="element-30" data-mp="2fzv031ajki33">
      <span data-id="element-31" data-mp="38pk2nj2wgq6t">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-32" data-mp="38m5z47ii2axs" />
    </a>;
}